<template lang="pug">
  div
    ReportSummary(
      v-bind:summary="report.summary"
      v-bind:simulations="simulations"
      v-bind:types="types"
    )

    ImageResourcesTable(
      v-bind:s3KeyBase="report.page.s3KeyBase"
      v-bind:summary="report.summary"
      v-bind:resources="resources"
      v-bind:simulations="simulations"
      v-bind:tableTitle="translate('table')"
    )
</template>

<script>
import ReportSummary from '@/components/ReportSummary.vue'
import ImageResourcesTable from '@/components/ImageResourcesTable.vue'

export default {
  components: {
    ReportSummary,
    ImageResourcesTable,
  },
  props: {
    report: Object,
  },
  methods: {
    translate(phrase) {
      return this.$t(`simulations.${this.report.summary.intent}.${phrase}`)
    },
  },
  computed: {
    simulations: () => ['orig', 'high', 'medium', 'low'],
    types: () => ['lightfile', 'jpg', 'png'],
    resources() {
      return this.report.resources
    },
  },
}
</script>